module.exports = __webpack_public_path__ + "img/video-camera.120b7b37.svg";